















































import Vue, { PropType } from 'vue';

const layoutType = ['pattern101', 'pattern102', 'pattern103', 'pattern1', 'pattern2', 'pattern3', 'pattern4', 'pattern5', 'pattern6', 'pattern7'];

export default Vue.extend({
  name: 'GItemLineupImage',
  props: {
    layout: {
      type: String as PropType<string>,
      validator: (prop: string) => layoutType.includes(prop),
      default: 'pattern1',
    },
    withNumber: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
});
